import { useCardStyles } from '@chakra-ui/react';
import React from 'react';

import { withChakraAs } from '../../utils/withChakraAs';
import type { HeadingProps } from '../Heading/Heading';
import { Heading } from '../Heading/Heading';

export type CardTitleProps = Omit<
  HeadingProps<'h2'>,
  'variant' | '__orbitStyleConfig'
>;

export const CardTitle = withChakraAs<CardTitleProps, 'h2'>((props) => {
  const styles = useCardStyles();
  const { size = 'xl', ...restProps } = props;

  return (
    <Heading {...restProps} size={size} __orbitStyleConfig={styles.title} />
  );
});
